export const BASE_URL = "https://api.rahnamayefarda.ir/api/"
